import { forwardRef, type Ref, type SVGProps } from "react";
const IconChecklistEmptyOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M6.5 10h-3A1.5 1.5 0 0 1 2 8.5v-3A1.5 1.5 0 0 1 3.5 4h3A1.5 1.5 0 0 1 8 5.5v3A1.5 1.5 0 0 1 6.5 10M4 8h2V6H4Zm2.5 11h-3A1.5 1.5 0 0 1 2 17.5v-3A1.5 1.5 0 0 1 3.5 13h3A1.5 1.5 0 0 1 8 14.5v3A1.5 1.5 0 0 1 6.5 19M4 17h2v-2H4Zm2.5 11h-3A1.5 1.5 0 0 1 2 26.5v-3A1.5 1.5 0 0 1 3.5 22h3A1.5 1.5 0 0 1 8 23.5v3A1.5 1.5 0 0 1 6.5 28M4 26h2v-2H4ZM29 8H12a1 1 0 0 1-1-1 1 1 0 0 1 1-1h17a1 1 0 0 1 1 1 1 1 0 0 1-1 1m0 9H12a1 1 0 0 1-1-1 1 1 0 0 1 1-1h17a1 1 0 0 1 1 1 1 1 0 0 1-1 1m0 9H12a1 1 0 0 1-1-1 1 1 0 0 1 1-1h17a1 1 0 0 1 1 1 1 1 0 0 1-1 1" />
  </svg>
);
const ForwardRef = forwardRef(IconChecklistEmptyOutlineSVG);
ForwardRef.displayName = "IconChecklistEmptyOutline";
export { ForwardRef as IconChecklistEmptyOutline };
